import { isolateComponent } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import { Link, Text } from '../../../index';
const Styles = {
    ctaDisclaimer: css `
    margin: 10px 0;
  `,
};
export const DisclaimerText = ({ color = 'primary', termsLink = 'https://zapier.com/tos', textType = 'paragraph3', privacyLink = 'https://zapier.com/privacy', }) => {
    const textColor = color === 'primary' ? 'neutral700' : 'neutral100';
    return (isolateComponent("div", { css: Styles.ctaDisclaimer },
        isolateComponent(Text, { tag: "p", type: textType, color: textColor },
            "By signing up, you agree to Zapier\u2019s",
            ' ',
            isolateComponent(Link, { href: termsLink, color: color }, "Terms of Service"),
            ' ',
            "and",
            ' ',
            isolateComponent(Link, { href: privacyLink, color: color }, "Privacy Policy"),
            ".")));
};
//# sourceMappingURL=DisclaimerText.js.map
// @zapier/design-system@6.27.0 (617a97f69)
